import React from 'react';
import { useParams } from 'react-router-dom';
import { env } from '../config/env';

const ToolEmbed: React.FC = () => {
  const { toolId } = useParams<{ toolId: string }>();

  if (!toolId) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6 text-sm text-gray-600 dark:text-gray-300">
        Tool ID ausente.
      </div>
    );
  }

  const apiBase = String(env.REACT_APP_API_URL || window.location.origin).replace(
    /\/+$/,
    ''
  );
  const src = `${apiBase}/embed/apps/${toolId}`;

  return (
    <div className="w-screen h-screen bg-white">
      <iframe
        className="w-full h-full border-0"
        title={`embed-tool-${toolId}`}
        src={src}
        sandbox="allow-scripts allow-forms"
      />
    </div>
  );
};

export default ToolEmbed;
